export const MODAL_TYPES = {
  CONNECT_WALLET: "CONNECT_WALLET",
  WALLET_MODAL: "wallet_modal",
  MOBILE_SIDEBAR_MENU_MODAL: "mobile_sidebar_menu_modal",
  WALLET_CONNECT_MESSAGE_MODAL: "wallet_connect_message_modal",
};
